import { useEffect, useState, useCallback } from 'react';
import { hasValidCurrencyInPortal } from 'invoices-ui-lib/utils/validation';
import http from 'hub-http/clients/apiClient';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { ACCOUNT_CURRENCIES_URL } from '../constants/urls';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const useInvoiceCurrencyValidator = (skip, onError) => {
  const [loading, setLoading] = useState(!skip);
  const [error, setError] = useState(false);
  const [currencies, setCurrencies] = useState([]);
  useEffect(() => {
    if (!skip) {
      http.get('payments/v1/limits/portal-currencies').then(portalCurrencies => {
        setCurrencies(portalCurrencies);
        setLoading(false);
      }).catch(currencyError => {
        setError(true);
        setLoading(false);
        if (onError) onError(currencyError);
      });
    }
  }, [skip, onError]);
  const currencyValidator = useCallback(currencyToCheck => {
    if (loading || error || skip) return null;
    if (currencyToCheck) {
      const isValidCurrency = currencies.some(curr => curr.currencyCode === currencyToCheck);
      if (!isValidCurrency) {
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "invoices.errors.editInvoiceMissingCurrencyError_jsx",
          elements: {
            UILink: Link
          },
          options: {
            href: ACCOUNT_CURRENCIES_URL,
            external: true
          }
        });
      }
    } else if (!hasValidCurrencyInPortal(currencies)) {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "invoices.errors.createInvoiceCurrencyError_jsx",
        elements: {
          UILink: Link
        },
        options: {
          href: ACCOUNT_CURRENCIES_URL,
          external: true
        }
      });
    }
    return null;
  }, [loading, currencies, error, skip]);
  return {
    loading,
    error,
    currencyValidator
  };
};
export default useInvoiceCurrencyValidator;